module.exports = __webpack_public_path__ + "img/หอยหลอด.258d450e.jpg";